import { Avatar, type AvatarProps } from '~/components/ui/Avatar';
import { Select } from '~/components/ui/Select';
import { userData } from '~/lib/client-github';
import { classNames } from '~/utils/classNames';

export interface OwnerOption {
  username: string;
  user?: AvatarProps['user'];
  id: string;
}

export function OwnerSelector<OPT extends OwnerOption = OwnerOption>({
  id,
  disabled,
  owners,
  owner,
  onChange,
  className,
}: {
  id: string;
  disabled?: boolean;
  owners: OPT | OPT[];
  owner: OPT;
  onChange: (owner: OPT) => void;
  className?: string;
}) {
  function handleUserChange(username: string) {
    const newOwner = (owners as OPT[]).find((owner) => owner.username === username)!;

    onChange(newOwner);
  }

  return Array.isArray(owners) ? (
    <div className={className}>
      <Select
        id={id}
        className={className}
        options={owners.map((owner) => ({ label: <UserOption owner={owner} />, value: owner.username }))}
        disabled={disabled}
        value={owner.username}
        onValueChange={handleUserChange}
      />
    </div>
  ) : (
    <UserOption owner={owner} className={className} />
  );
}

function UserOption({ owner, className }: { owner: OwnerOption; className?: string }) {
  return (
    <div className={classNames(className, 'flex items-center')}>
      <Avatar user={userData(owner.user, owner.username)} />

      <span className="w-4" />

      <code className="">{owner.username}</code>
    </div>
  );
}
